export default __webpack_public_path__ + "static/media/no-documents.ef86350e.svg";